import config from 'config';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import LibraryApiCall from 'LibraryApiCall';
import moment from 'moment';
import { Component } from 'react';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import "./noDueCertificate.css";
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';

class NoDueCertificate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            facultyDepartment: {},
            facultyStream: "",
            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            // VARIABLES TO SEARCH BY FILTERS
            searchUserID: '',
            noDueCertificateStatus: 'active',
            filterIssuedOnData: "",
            filterFromDateData: "",
            filterToDateData: "",

            // VARIABLES TO SELECT FACULTY/STUDENT
            selectedUserIds: [],

            //VARIABLE TO GET NO DUE CERTIFICATE DATA LIST
            noDueCertificateDataList: {},
            totalNoDueCertificate: 0,
            accessNoDueCertificateList: false,

            //VARIABLES TO GET VALUE FOR PRINT CERTIFICATE DATA
            noDueCertificateTemplate: '',
            noDueCertificateDataHTML: '',
            noDueCertificateDesign: {},
            fetchingCertificateDetails: false,
            selectedCertificateUniqueId: "",
            defaultNoReceiptDesign: '',

            // VARIABLES TO EXPORT NO DUE
            exportDetails: false,
        }
    }

    componentDidMount() {
        this.apiCallToGetLibraryNoDueCertificateList();
        this.GetInstituteStreamsObject();
        this.apiCallToGetLibraryReceipt();
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    GetInstituteStreamsObject = async () => {
        let requestData = {
            "iid": config.institute_id,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        facultyDepartment: apiResult.data
                    })
                }
                else {
                    this.setState({
                        facultyDepartment: {},
                    })
                }
            } else {
                this.setState({
                    facultyDepartment: {},
                })
            }
        }
    }

    // API CALL TO GET NO DUE CERTIFICATE DATA LIST
    apiCallToGetLibraryNoDueCertificateList = async () => {

        this.setState({
            accessNoDueCertificateList: true
        });

        let issuedOnDate = '';
        let fromDateValue = '';
        let toDateValue = '';

        if (this.state.filterIssuedOnData != '') {
            issuedOnDate = moment(this.state.filterIssuedOnData).format('YYYY-MM-DD');
        }
        if (this.state.filterFromDateData != '') {
            fromDateValue = moment(this.state.filterFromDateData).format('YYYY-MM-DD');
        }
        if (this.state.filterToDateData != '') {
            toDateValue = moment(this.state.filterToDateData).format('YYYY-MM-DD');
        }

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "userId": this.state.searchUserID,
            "status": this.state.noDueCertificateStatus,
            "issuedOn": issuedOnDate,
            "fromDate": fromDateValue,
            "toDate": toDateValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLibraryNoDueCertificate',
            requestData,
            "/api/library/libraryNoDueCertificate.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryNoDueCertificateList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {

                        this.setState({
                            noDueCertificateDataList: apiResult.data,
                            totalNoDueCertificate: apiResult.totalCount,
                            accessNoDueCertificateList: false,
                        })
                    }
                    else {
                        this.setState({
                            noDueCertificateDataList: {},
                            totalNoDueCertificate: 0,
                            accessNoDueCertificateList: false,

                        })
                    }
                } else {
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    this.setState({
                        noDueCertificateDataList: {},
                        totalNoDueCertificate: 0,
                        accessNoDueCertificateList: false,

                    })
                }
            } else {
                this.setState({
                    noDueCertificateDataList: {},
                    totalNoDueCertificate: 0,
                    accessNoDueCertificateList: false,

                })
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET NO DUE CERTIFICATE DETAILS
            this.apiCallToGetLibraryNoDueCertificateList();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            selectedUserIds: []
        }, () => {
            // METHOD CALLED TO GET NO DUE CERTIFICATE DETAILS
            this.apiCallToGetLibraryNoDueCertificateList();
        });
    }

    // METHOD TO SELECT ALL USERS
    selectAllUsers = (e) => {
        let userSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.noDueCertificateDataList).length > 0) {
                Object.keys(this.state.noDueCertificateDataList).map(employeeId => {
                    userSet.add(employeeId);
                });
            }
        }

        this.setState({
            selectedUserIds: Array.from(userSet),
        });
    }

    // // METHOD TO SELECT SINGLE EMPLOYEE
    selectSingleUser = (userID) => {

        let selectedUserIds = this.state.selectedUserIds;

        if (selectedUserIds.includes(userID)) {
            selectedUserIds = selectedUserIds.filter(id => id != userID);
        } else {
            selectedUserIds.push(userID);
        }
        this.setState({
            selectedUserIds,
        });
    }

    // METHOD TO UPDATE NO DUE CERTIFICATE STATUS
    apiCallToUpdateNoDueCertificate = async (status) => {

        let requestData = {
            "iid": config.institute_id,
            "noDue_unique_id": this.state.selectedUserIds,
            "updatedBy": config.faculty_id,
            "status": status
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_UpdateLibraryNoDueCertificate',
            requestData,
            '/api/library/libraryNoDueCertificate.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateNoDueCertificate()
            }, 1000);
        } else {
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == "success") {

                    this.setState({
                        selectedUserIds: []
                    });
                    toast.success(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToGetLibraryNoDueCertificateList();

                } else {
                    this.setState({
                        selectedUserIds: []
                    });
                    toast.warn(apiResult.message, {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Something went wrong while getting student list. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO CHECK ACCESS FOR UPDATE OPERATION
    updateCertificateStatus = (status) => {

        const updateGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['noDueCertificate'].find(access => access === 'update');

        if (updateGrantAccess !== undefined) {

            this.apiCallToUpdateNoDueCertificate(status);
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CLEAR FILTER
    clearFilter = () => {
        this.setState({
            noDueCertificateStatus: 'active',
            searchUserID: '',
            filterIssuedOnData: "",
            filterFromDateData: "",
            filterToDateData: "",
            filterApplied: false,
            pageIndex: 1,
            offset: 0
        }, () => this.apiCallToGetLibraryNoDueCertificateList());
    }

    // API CALL TO GET NO DUE LIBRARY RECEIPT
    apiCallToGetLibraryReceipt = async () => {
        this.setState({
            fetchingCertificateDetails: true,
        });

        let requestData = {
            "iid": config.institute_id,
            "searchType": "noDue"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryReceipt',
            requestData,
            "/api/library/libraryReceiptDesign.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryReceipt();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                let defaultCertificate = '';
                let defaultCertificateData = '';

                Object.keys(apiResult).map((uniqueKey, index) => {
                    let unique_id = uniqueKey;
                    defaultCertificate = apiResult[uniqueKey]['isDefault'];

                    if (defaultCertificate == 'yes') {
                        this.state.selectedCertificateUniqueId = unique_id;
                        this.setState({ defaultNoReceiptDesign: false })
                    } else {
                        this.setState({ defaultNoReceiptDesign: true })
                    }
                    defaultCertificateData = apiResult[this.state.selectedCertificateUniqueId]

                });
                this.setState({
                    noDueCertificateDesign: defaultCertificateData,
                    fetchingCertificateDetails: false,
                });

            } else {
                this.setState({
                    fetchingCertificateDetails: false,
                });

                toast.error('Something went wrong while getting student list. Please try again later.', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    // METHOD TO DISPLAY NO DUE CERTIFICATE DATA 
    displayNoDueCertificate = (individualNoDueUserData) => {
        this.apiCallToAddLibraryPrintHistory(individualNoDueUserData)

        this.setState({
            noDueCertificateDataHTML: '',
            noDueCertificateTemplate: '',
        })

        let dataOfNoDueUser = individualNoDueUserData
        let parametersArray = [];
        let noDueCertificateTemplate = this.state.noDueCertificateTemplate;

        let parameters = {
            "Role": dataOfNoDueUser?.userRole ?? "",
            "ERP_Id": dataOfNoDueUser?.userERPId ?? "",
            "User_Name": dataOfNoDueUser?.userName ?? "",
            "Student_Prn_University_No": dataOfNoDueUser.studentPrnUniversityNo ?? "",
            "Student_Grn_No": dataOfNoDueUser.studentGrnNo ?? "",
            "Student_Seat_No": dataOfNoDueUser.studentSeatNo ?? "",
            "Student_Roll_No": dataOfNoDueUser.studentRollNo ?? "",
            "Student_First_Name": dataOfNoDueUser.studentFirstName ?? "",
            "Student_Middle_Name": dataOfNoDueUser.studentMiddleName ?? "",
            "Student_Last_Name": dataOfNoDueUser.studentLastName ?? "",
            "Employee_Id": dataOfNoDueUser.employeeId ?? "",
            "Employee_First_Name": dataOfNoDueUser.employeeFirstName ?? "",
            "Employee_Middle_Name": dataOfNoDueUser.employeeMiddleName ?? "",
            "Employee_Last_Name": dataOfNoDueUser.employeeLastName ?? "",
        };
        parametersArray.push(parameters);

        let value = this.state.noDueCertificateDesign
        noDueCertificateTemplate = value?.receipt_design || "";
        let certificateHTML = noDueCertificateTemplate

        parametersArray.forEach((parameters, index) => {
            for (let fieldName in parameters) {
                if (certificateHTML.includes("{" + fieldName + "}")) {
                    if (fieldName == "Role") {
                        //if present replace it with it's value
                        //code to replace filed 
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "ERP_Id") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "User_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Prn_University_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Grn_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Seat_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Roll_No") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_First_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Middle_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Student_Last_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Id") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_First_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Middle_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }
                    else if (fieldName == "Employee_Last_Name") {
                        var find = "{" + fieldName + "}";
                        var re = new RegExp(find, 'g');
                        certificateHTML = certificateHTML.replace(re, parameters[fieldName]);
                    }

                }
            }
        });

        this.setState({
            noDueCertificateDataHTML: certificateHTML,
            noDueCertificateTemplate
        });
    }

    // API CALL TO Library Print History
    apiCallToAddLibraryPrintHistory = async (data) => {
        if (this.state.selectedCertificateUniqueId) {
            let requestData = {
                "iid": config.institute_id,
                "receipt_id": this.state.selectedCertificateUniqueId,
                "printedBy": config.faculty_id,
                "issueReturnUId": data?.uniqueId,
                "printedByRole": "faculty",
                "source": "web",
                "type": "noDue"
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'addLibraryPrintHistory',
                requestData,
                "/api/library/libraryReceiptDesign.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToAddLibraryPrintHistory();
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                }
            }
        } else if (this.state.defaultNoReceiptDesign == true) {
            toast.warn("No default design for no due certificate.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            toast.error("No Receipt design for no due certificate.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    // METHOD TO EXPORT EXPENSES DETAILS
    exportNoDueDetails = () => {
        this.setState({
            exportDetails: true
        }, () => {
            document.getElementById('noDueExport').click();

            this.setState({
                exportDetails: false
            });
        });
    }

    render() {
        return (
            <>
                <RoutingMenu activeScreen="noDueCertificate" />

                <div className="libraryComponents-container">
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4>No Due Certificates</h4>
                        </div>
                        {/* filter */}
                        <div className="d-flex justify-content-between align-items-start">
                            {/* LEFT SIDE – FILTER FIELDS */}
                            <div className="d-flex flex-wrap col-md-10 px-0">
                                <div className="col-md-3 pl-0 pr-1">
                                    <label className='fs-13 headColor'>Search by</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ fontSize: '13px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                        placeholder="Search by ERP Id/ PRN/ University No./Employee ID"
                                        value={this.state.searchUserID}
                                        onChange={(e) => this.setState({ searchUserID: e.target.value })}
                                    />
                                </div>

                                <div className='col-md-2 pl-0 pr-1'>
                                    <label className='fs-13 headColor'>Status</label>
                                    <select
                                        className="form-control"
                                        style={{ fontSize: '13px' }}
                                        value={this.state.noDueCertificateStatus}
                                        onChange={(e) => this.setState({ noDueCertificateStatus: e.target.value })}
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>

                                <div className='col-md-2 pl-0 pr-1'>
                                    <label className='fs-13 headColor'>Issued On</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px' }}
                                        value={this.state.filterIssuedOnData}
                                        onChange={(e) => this.setState({ filterIssuedOnData: e.target.value })}
                                    />
                                </div>

                                <div className='col-md-2 pl-0 pr-1'>
                                    <label className='fs-13 headColor'>From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px' }}
                                        value={this.state.filterFromDateData}
                                        onChange={(e) => this.setState({ filterFromDateData: e.target.value })}
                                    />
                                </div>

                                <div className='col-md-2 pl-0 pr-1'>
                                    <label className='fs-13 headColor'>To Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ fontSize: '14px', paddingLeft: '10px' }}
                                        value={this.state.filterToDateData}
                                        onChange={(e) => this.setState({ filterToDateData: e.target.value })}
                                    />
                                </div>

                                <div className='col-md pl-0 d-flex mt-4'>
                                    <button className="btn btn-primary px-2 py-1 br-5"
                                        onClick={() => this.setState({ offset: 0, pageIndex: 1 }, () => this.apiCallToGetLibraryNoDueCertificateList())}>
                                        <span className='fs-12'>Apply</span>
                                    </button>
                                    <button className="btn btn-outline-primary waves-effect px-2 py-1 br-5 ml-2"
                                        onClick={() => this.clearFilter()}>
                                        <span className='fs-12'>Clear</span>
                                    </button>
                                </div>
                            </div>

                            <div style={{ display: 'none' }}>
                                <ReactHTMLTableToExcel
                                    id="noDueExport"
                                    className="btn outline-button waves-effect text-capitalize"
                                    table='expenseTable'
                                    filename="No due certificate list"
                                    sheet="tablexls"
                                    buttonText="Export to Excel"
                                />
                            </div>
                            {/* RIGHT SIDE – EXPORT BUTTON */}
                            <div className="col-md-2 d-flex justify-content-end mt-3">
                                <button
                                    className="btn btn-outline-primary"
                                    title="Click here to export"
                                    onClick={() => this.exportNoDueDetails()}
                                >
                                    {this.state.accessNoDueCertificateList ?
                                        <ButtonLoader /> :
                                        <><FontAwesomeIcon icon={['fas', 'file-export']} size="md" style={{ marginRight: 10 }} /> Export</>}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive col-md-12" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                        <table class="table jumbotron" id='expenseTable'>
                            <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                {/* Hidden rows for titles, etc. */}
                                <tr className='d-none'>
                                    <th colSpan="8" style={{ textAlign: 'center' }}>{config.institute_name}</th>
                                </tr>
                                <tr className='d-none'>
                                    <th colSpan="8" style={{ textAlign: 'center' }}>No Due Certificate</th>
                                </tr>
                                <tr className='d-none'>
                                    <th colSpan="8" ></th>
                                </tr>
                                <tr>
                                    {
                                        !this.state.exportDetails &&
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={Object.keys(this?.state?.noDueCertificateDataList).length > 0 && (Object.keys(this?.state?.noDueCertificateDataList).length == this?.state?.selectedUserIds?.length)}
                                                onChange={(e) => this.selectAllUsers(e)}
                                                style={{ marginRight: 5 }}
                                            />
                                        </th>
                                    }
                                    <th scope="col">Sr. No.</th>
                                    <th scope="col">Role</th>
                                    <th scope="col">ERP ID</th>
                                    <th scope="col">Issued To</th>
                                    <th scope="col">PRN/University Number</th>
                                    <th scope="col">Employee ID</th>
                                    {/* <th scope="col">Issued By</th>
                                    <th scope="col">Issued On</th>
                                    <th scope="col">Last Updated By</th>
                                    <th scope="col">Last Updated On</th> */}
                                    <th scope="col">Last Modified By</th>
                                    <th scope="col">Status</th>
                                    {!this.state.exportDetails && <th scope="col">Print</th>}
                                </tr>
                                {
                                    this.state.selectedUserIds.length > 0 &&
                                    <tr style={{ backgroundColor: "#eff7ff" }}>
                                        <th colSpan="13" style={{ padding: '10px' }}>
                                            <div className="">
                                                <span id="noDueStatus" title="Mark as active" onClick={() => this.updateCertificateStatus('active')}>
                                                    Active
                                                </span>
                                                <span id="noDueStatus" title="Mark as inactive" onClick={() => this.updateCertificateStatus('inactive')}>
                                                    Inactive
                                                </span>
                                            </div>
                                        </th>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {
                                    this.state.accessNoDueCertificateList ?
                                        <tr>
                                            <Spinner />
                                        </tr>
                                        :
                                        Object.keys(this.state.noDueCertificateDataList).length > 0 ?
                                            Object.values(this.state.noDueCertificateDataList).reverse().map((users, index) => {

                                                // handle role
                                                let role = "";

                                                if (users?.userRole == "faculty" || users?.userRole == "teaching" || users?.userRole == "nonteaching") {
                                                    role = "Faculty";
                                                } else {
                                                    role = "Student";
                                                }

                                                return (
                                                    <>
                                                        <tr>
                                                            {
                                                                !this.state.exportDetails &&
                                                                <th>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={this.state.selectedUserIds.includes(users.uniqueId.toString())}
                                                                        onChange={() => this.selectSingleUser(users.uniqueId.toString())}
                                                                        style={{ marginRight: 5 }}
                                                                    />
                                                                </th>
                                                            }
                                                            <td style={{ padding: '0.5rem' }}>{this.state.offset + index + 1}</td>
                                                            <td style={{ padding: '0.5rem' }}>{role}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users.userERPId ? users.userERPId : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users.userSalutation ? users.userSalutation : ""}&nbsp;{users.userName}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users.studentPrnUniversityNo ? users.studentPrnUniversityNo : ""}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users.employeeId ? users.employeeId : ""}</td>
                                                            {/* <td style={{ padding: '0.5rem' }}>{users.issuedByName ? users.issuedByName : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users?.issuedOn !=
                                                                "0000-00-00 00:00:00" ? moment(users?.issuedOn).format('DD MMM YYYY') : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users.updatedByName ? users.updatedByName : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{users?.updatedOn !=
                                                                "0000-00-00 00:00:00" ? moment(users?.updatedOn).format('DD MMM YYYY') : '-'}
                                                            </td> */}
                                                            <td style={{ padding: '0.5rem', cursor: "pointer", color: users.uniqueId == this.state.hoverID ? "#0465AC" : "" }}
                                                                onMouseEnter={() => this.setState({ hoverID: users.uniqueId })}
                                                                onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                onClick={() => this.openActivitySlider(users.uniqueId)}>
                                                                {users.updatedByName ? (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{users.updated_by_Name} ({users.last_updated_by_ERP}) | {users.updatedOn}</div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{users.added_by_name} ({users.added_by_ERP}) | {users.added_On}</div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td style={{ padding: '0.5rem' }}>
                                                                <span style={{ padding: "8px" }}>{users.status === 'active' ? 'Active' : 'Inactive'}</span>
                                                            </td>
                                                            {!this.state.exportDetails &&
                                                                <td style={{ padding: '0.5rem', cursor: "pointer" }} title="Click here to print">
                                                                    <div onClick={() => { this.displayNoDueCertificate(users) }}>
                                                                        <ReactToPrint
                                                                            trigger={() => {
                                                                                return <p className="outlineButton pl-3">
                                                                                    <FontAwesomeIcon icon={['fas', 'print']} style={{ fontSize: '16px', marginRight: 5 }} />
                                                                                </p>;
                                                                            }}
                                                                            content={() => this.printCertificate}
                                                                            onBeforeGetContent={() => {
                                                                                return new Promise((resolve) => {
                                                                                    if (this.state.noDueCertificateDataHTML) {
                                                                                        resolve();
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                            }
                                                        </tr>
                                                    </>
                                                );
                                            })
                                            :
                                            <tr>
                                                <td style={{ padding: 5 }} colSpan={13}>The No Due Certificate has not been issued yet.</td>
                                            </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="p-4 display-none" ref={el => this.printCertificate = el}>
                        {
                            this.state.fetchingCertificateDetails
                                ?
                                <div className='w-100 h-100 align-center bold text-black-50'>
                                    Loading Certificate . . .&nbsp;
                                    <FontAwesomeIcon icon={['fas', 'circle-notch']} size='lg' className='rotate' />
                                </div>
                                :
                                ReactHtmlParser(this.state.noDueCertificateDataHTML)
                        }
                    </div>

                    <div className="pr-4">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                            <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                <span >Show</span>
                                <select
                                    className="mx-2"
                                    value={this.state.limit}
                                    onChange={(e) => this.selectLimit(e)}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={40}>40</option>
                                    <option value={100}>100</option>
                                    <option value={250}>250</option>
                                </select>
                                <span>entries</span>
                            </div>

                            <div id="paginationContainer">
                                <Pagination
                                    activePage={this.state.pageIndex}
                                    itemsCountPerPage={this.state.limit}
                                    totalItemsCount={this.state.totalNoDueCertificate}
                                    pageRangeDisplayed={3}
                                    onChange={(num) => this.updatePaginationCount(num)}
                                />
                            </div>

                            <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalNoDueCertificate} </p>
                        </div>
                    </div>
                </div>

                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["no_due_certificate_issued", "No_Due_Certificate_status_updated"]}
                    />
                }
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(NoDueCertificate);
